import { localeDe } from '@mobiscroll/react';
import moment from 'moment';

export function setupMomentJsLocales() {
  moment.defineLocale('de-DE', {
    weekdays: localeDe.dayNames,
    weekdaysMin: localeDe.dayNamesShort,
    weekdaysShort: ['Son', 'Mon', 'Die', 'Mit', 'Don', 'Fre', 'Sam'],
    months: localeDe.monthNames,
    monthsShort: localeDe.monthNamesShort,
    relativeTime: {
      M: 'ein Monat',
      MM: '%d Monate',
      d: 'ein Tag',
      dd: '%d Tage',
      future: 'in %s',
      h: 'eine Stunde',
      hh: '%d Stunden',
      m: 'eine Minute',
      mm: '%d Minuten',
      past: '%s her',
      s: 'ein paar Sekunden',
      ss: '%d Sekunden',
      w: 'eine Woche',
      ww: '%d Wochen',
      y: 'ein Jahr',
      yy: '%d Jahre',
    },
    longDateFormat: {
      L: localeDe.dateFormat,
      LL: 'DD. MMMM YYYY',
      LLL: 'DD. MMMM YYYY HH:mm [Uhr]',
      LLLL: 'dddd, DD. MMMM YYYY HH:mm [Uhr]',
      LT: 'HH:mm [Uhr]',
      LTS: 'HH:mm:ss [Uhr]',
    },
    invalidDate: 'Ungültiges Datum',
    eras: [
      { since: '0001-01-01', offset: 1, name: 'Nach Christus', abbr: 'n. Chr.', narrow: 'AD', until: Infinity },
      { since: '0000-12-31', offset: 1, name: 'Vor Christus', abbr: 'v. Chr.', narrow: 'AC', until: -Infinity },
    ],
  });
}
